import React, { useEffect } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";

import { actionCreators as lineItemManagementActionCreators } from "../lineItemManagement.store";
import { actionCreators as drawerActionCreators } from "../../lenderReportingDrawer.store";

import ComparisonFieldCard from "./comparisonFieldCard";
import { ComparisonWrapper, StyledOR, StyledButtonText } from "./styles";

const ComparisonLineItems = props => {
  const {
    setNewLineItemSelections,
    setDrawerSelections,
    properties,
    isMultipleProperties,
    multiplePropertiesComparisonFields,
    multiPropComparisonSubLineItemNames,
    singlePropertyComparisonCards
  } = props;

  useEffect(() => {
    if (!multiplePropertiesComparisonFields && isMultipleProperties) {
      const propertiesComparisonSelections = new Array(2)
        .fill([])
        .map(() => properties && properties.map(prop => ({ propertyId: prop.id, propertyName: prop.name, selectedField: null })));
      setNewLineItemSelections({ multiplePropertiesComparisonFields: propertiesComparisonSelections });
    }
  }, [properties]);

  const handleInputNameChange = (event, index) => {
    if (!isMultipleProperties) {
      const updatedComparisonCards = singlePropertyComparisonCards.map((card, idx) => {
        if (idx === index) {
          return { ...card, name: event.target.value };
        }

        return card;
      });
      setNewLineItemSelections({ singlePropertyComparisonCards: updatedComparisonCards });
    } else {
      const updatedNames = multiPropComparisonSubLineItemNames.map((name, idx) => {
        if (idx === index) {
          return event.target.value;
        }

        return name;
      });
      setNewLineItemSelections({ multiPropComparisonSubLineItemNames: updatedNames });
    }
  };

  const openSelectFieldDrawer = (index, propertyId) => {
    setDrawerSelections({ currentSectionName: "comparison-field-selection" });
    setNewLineItemSelections({ propertyIdSelected: propertyId || null, activeCardIndex: index });
  };

  const onAddComparisonCard = () => {
    if (!isMultipleProperties) {
      const updatedComparisonCards = [...singlePropertyComparisonCards, { name: "", selectedField: null }];
      setNewLineItemSelections({ singlePropertyComparisonCards: updatedComparisonCards });
    } else {
      const newCard = properties.map(prop => ({ propertyId: prop.id, propertyName: prop.name, selectedField: null }));
      const updatedSubGroupNames = [...multiPropComparisonSubLineItemNames, ""];
      setNewLineItemSelections({
        multiplePropertiesComparisonFields: [...multiplePropertiesComparisonFields, newCard],
        multiPropComparisonSubLineItemNames: updatedSubGroupNames
      });
    }
  };

  const onRemoveCard = cardIndex => {
    if (!isMultipleProperties) {
      const updatedComparisonCards = singlePropertyComparisonCards.filter((_, index) => index !== cardIndex);
      setNewLineItemSelections({ singlePropertyComparisonCards: updatedComparisonCards });
    } else {
      const updatedComparisonCards = multiplePropertiesComparisonFields.filter((_, index) => index !== cardIndex);
      const updatedSubGroupNames = multiPropComparisonSubLineItemNames.filter((_, index) => index !== cardIndex);
      setNewLineItemSelections({ multiplePropertiesComparisonFields: updatedComparisonCards, multiPropComparisonSubLineItemNames: updatedSubGroupNames });
    }
  };

  const maxAmountOfComparisonCards = 4;

  return (
    <ComparisonWrapper>
      {!isMultipleProperties && (
        <div style={{ display: "flex", flexDirection: "column" }}>
          {singlePropertyComparisonCards.map((card, index) => (
            <div key={index} style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
              <ComparisonFieldCard
                cardIndex={index}
                handleChange={handleInputNameChange}
                value={card.name}
                handleSelect={openSelectFieldDrawer}
                onRemoveCard={onRemoveCard}
                cardsAmount={singlePropertyComparisonCards.length}
                comparisonCard={card}
                isMultipleProperties={isMultipleProperties}
              />
              {index < singlePropertyComparisonCards.length - 1 && (<StyledOR value="OR" />)}
            </div>
          ))}

          {singlePropertyComparisonCards.length < maxAmountOfComparisonCards && (
            <div style={{ display: "flex", justifyContent: "center", paddingBottom: "1em" }}>
              <StyledButtonText
                reverse
                label="Add another comparison item"
                iconName="add_circle_outline"
                onClick={onAddComparisonCard}
              />
            </div>
          )}
        </div>
      )}
      {isMultipleProperties && (
        <div style={{ display: "flex", flexDirection: "column" }}>
          {multiplePropertiesComparisonFields && multiplePropertiesComparisonFields.map((comparisonGroup, index) => (
            <div key={index} style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
              <ComparisonFieldCard
                cardIndex={index}
                handleChange={handleInputNameChange}
                value={multiPropComparisonSubLineItemNames[index]}
                handleSelect={openSelectFieldDrawer}
                onRemoveCard={onRemoveCard}
                cardsAmount={multiplePropertiesComparisonFields.length}
                comparisonCard={comparisonGroup}
                isMultipleProperties={isMultipleProperties}
                multiplePropertiesComparisonFields={multiplePropertiesComparisonFields}
                setNewLineItemSelections={setNewLineItemSelections}
              />
              {index < multiplePropertiesComparisonFields.length - 1 && (<StyledOR value="OR" />)}
            </div>
          ))}

          {multiplePropertiesComparisonFields?.length < maxAmountOfComparisonCards && (
            <div style={{ display: "flex", justifyContent: "center", paddingBottom: "1em" }}>
              <StyledButtonText
                reverse
                label="Add another comparison item"
                iconName="add_circle_outline"
                onClick={onAddComparisonCard}
              />
            </div>
          )}
        </div>
      )}
    </ComparisonWrapper>
  );
};

const mapStateToProps = ({ lenderReportNewLineItemManagement }) => ({ ...lenderReportNewLineItemManagement });

const mapDispatchToProps = dispatch => bindActionCreators({ ...lineItemManagementActionCreators, ...drawerActionCreators }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(ComparisonLineItems);
